import { FC } from 'react';

import multicreationAlertPartlyFailedProblemsButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/auction/multicreation/multicreation_alert_partly_failed_problems_button_click';
import { Alert, Button, ButtonStack } from '@hh.ru/magritte-ui';
import { ExclamationTriangleFilledSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    title: 'MultiCreationAuction.CreationPartialFailedAlert.title',
    description: 'MultiCreationAuction.CreationPartialFailedAlert.description',
    button: 'MultiCreationAuction.CreationPartialFailedAlert.button',
};

interface CreationPartialFailedAlertProps {
    isVisible: boolean;
    closeAlert: () => void;
}

export const CreationPartialFailedAlert: FC<CreationPartialFailedAlertProps> = ({ isVisible, closeAlert }) => {
    const trls = useTrls();

    const handleCloseAlert = () => {
        multicreationAlertPartlyFailedProblemsButtonClick();
        closeAlert();
    };

    return (
        <>
            <Alert
                title={trls(TrlKeys.title)}
                description={trls(TrlKeys.description)}
                buttons={
                    <ButtonStack stretched layout="vertical">
                        <Button
                            data-qa="close-button"
                            mode="secondary"
                            onClick={handleCloseAlert}
                            size="medium"
                            style="accent"
                            stretched
                        >
                            {trls(TrlKeys.button)}
                        </Button>
                    </ButtonStack>
                }
                visible={isVisible}
                onClose={handleCloseAlert}
            >
                <ExclamationTriangleFilledSize24
                    initialColor="warning"
                    backgroundStyle="warning-secondary"
                    padding={12}
                    borderRadius="halfHeight"
                />
            </Alert>
        </>
    );
};
